import _ from 'lodash';
import React from 'react';
import { copilotConfiguration } from 'config/copilot.js';
import { ApplicationContainer } from '@janus.team/janus-copilot';
import { translations } from '@janus.team/janus-particles';
import { Webhooks } from 'webhooks';
import { Switch, Route, Redirect, useParams } from 'react-router-dom';

export const RackerAppReady = () => (
  <Switch>
    <Route path="/racker/search">
      <div>Racker search page ?</div>
    </Route>
    <Route path="/racker/customers/:domainId/webhooks">
      <Webhooks />
    </Route>
    <Redirect to="/racker/search" />
  </Switch>
);

const RootRackerApp = () => {
  const t = translations.useT();
  return (
    <ApplicationContainer {...copilotConfiguration({ racker: true })}>
      <ApplicationContainer.Authenticating>
        <ApplicationContainer.FanaticGuyLogo>
          {t('Authenticating...')}
        </ApplicationContainer.FanaticGuyLogo>
      </ApplicationContainer.Authenticating>
      <ApplicationContainer.Ready>
        <RackerAppReady />
      </ApplicationContainer.Ready>
    </ApplicationContainer>
  );
};
const CustomerRackerApp = () => {
  const { domainId: rackspaceAccountNumber } = useParams();
  const t = translations.useT();
  return (
    <ApplicationContainer {...copilotConfiguration({ racker: true, rackspaceAccountNumber })}>
      <ApplicationContainer.Authenticating>
        <ApplicationContainer.FanaticGuyLogo>
          {t('Authenticating...')}
        </ApplicationContainer.FanaticGuyLogo>
      </ApplicationContainer.Authenticating>
      <ApplicationContainer.Ready>
        <RackerAppReady />
      </ApplicationContainer.Ready>
    </ApplicationContainer>
  );
};
export const RackerApp = () => _.set(global, 'isRacker', true) && (
  <Switch>
    <Route path="/racker/customers/:domainId">
      <CustomerRackerApp />
    </Route>
    <Route path="/racker">
      <RootRackerApp />
    </Route>
  </Switch>
);